export enum UploaderExternalIds {
  Filestack = 'filestack',
  TransloadIt = 'transloadit'
}

export enum UploaderSources {
  Filestack = 'filestack',
  Uppy = 'uppy'
}
